import { render, staticRenderFns } from "./PasswordStrength.vue?vue&type=template&id=3b9dafbb"
import script from "./PasswordStrength.vue?vue&type=script&lang=ts"
export * from "./PasswordStrength.vue?vue&type=script&lang=ts"
import style0 from "./PasswordStrength.vue?vue&type=style&index=0&id=3b9dafbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports